<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">Transferência</strong>
            </div>
          </header>

          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div class="card-body" v-else>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <small>Campos com * são de preenchimento obrigatório</small>
                </div>
              </div>
            </div>

            <form @submit="ValidarForm">
              <div class="row">
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for="">Tipo</label>
                    <b-form-radio
                      v-model="isGaau"
                      v-bind:value="true"
                      name="gaau-radio"
                      >GAAU</b-form-radio
                    >
                    <b-form-radio
                      v-model="isGaau"
                      v-bind:value="false"
                      name="gaau-radio"
                      >Inventário</b-form-radio
                    >
                  </div>
                </div>

                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for="">* Operação</label>
                    <b-form-radio
                      v-model="viewModel.type"
                      name="type-radio"
                      value="Transfer"
                      required
                      >Transferir</b-form-radio
                    >
                    <b-form-radio
                      v-model="viewModel.type"
                      name="type-radio"
                      value="Copy"
                      required
                      >Copiar</b-form-radio
                    >
                  </div>
                </div>
                <div class="col-sm-6 col-md-2 col-lg-2 col-xl-1">
                  <label for>Com Imagens</label>
                  <b-form-checkbox
                    v-model="viewModel.withImage"
                    name="check-button"
                    switch
                  >
                    Sim
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>* Projeto Origem</label>
                    <v-select
                      placeholder="Digite o nome do projeto"
                      v-model="projectFrom"
                      :options="projects"
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>* Projeto Destino</label>
                    <v-select
                      placeholder="Digite o nome da situação"
                      v-model="projectTo"
                      :options="projects"
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-groupd">
                    <label for="">ID Início</label>
                    <input
                      class="form-control"
                      type="number"
                      v-model="viewModel.item.from"
                      min="0"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for="">ID Fim</label>
                    <input
                      class="form-control"
                      type="number"
                      v-model="viewModel.item.to"
                      min="0"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="btn-toolbar mb-3 mt-3" role="toolbar">
                <div class="btn-group" role="group">
                  <button class="btn btn-success mr-2" type="submit">
                    Salvar
                  </button>
                </div>
                <div class="btn-group" role="group">
                  <button
                    class="btn btn-secondary"
                    type="reset"
                    @click="$router.go(-1)"
                  >
                    Voltar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import RotateSquare from "../../components/RotateSquare";
import ProjectService from "../../servico/ProjectService";
import TransferService from "../../servico/TransferService";

export default {
  name: "Transfer",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      projects: [],
      projectTo: "",
      projectFrom: "",
      viewModel: {
        projectTo: "",
        projectFrom: "",
        type: "",
        withImage: true,
        item: { from: null, to: null }
      },
      transferTypes: [
        { value: "Transfer", text: "Transferir" },
        { value: "Copy", text: "Copiar" }
      ],
      isGaau: true
    };
  },
  mounted() {
    this.GetProjects(this.isGaau);
  },
  watch: {
    isGaau: function (val) {
      this.GetProjects(val);
      this.isGaau = val;
      this.projectTo = "";
      this.projectFrom = "";
    }
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      this.Save();
    },
    GetProjects(val) {
      ProjectService.GetVSelect("    ", val)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },

    Save() {
      if (this.isGaau) this.TransferGaau();
      else this.TransferInventory();
    },
    TransferGaau() {
      this.loading = true;
      TransferService.Gaau(this.MouteModel())
        .then((result) => {
          this.loading = false;
          this.ShowMessage();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    TransferInventory() {
      this.loading = true;
      TransferService.Inventory(this.MouteModel())
        .then((result) => {
          this.loading = false;
          this.ShowMessage();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    ShowMessage() {
      this.$notify({
        data: ["Operação realizada com sucesso."],
        type: "success",
        duration: 5000
      });
    },
    MouteModel() {
      this.viewModel.projectFrom = this.projectFrom.id;
      this.viewModel.projectTo = this.projectTo.id;
      return this.viewModel;
    }
  }
};
</script>
    